export default "__VITE_ASSET__P_W$RE_G__"